import React from 'react';

// Simple spinner keyframes
const spinnerStyles = `
  @keyframes bb-session-spinner {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

/**
 * Loading component with centered spinner
 * Used during session initialization
 */
const LoadingScreen = () => (
  <>
    <style>{spinnerStyles}</style>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#0f172a',
      }}
    >
      <div
        style={{
          width: '56px',
          height: '56px',
          animation: 'bb-session-spinner 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite',
        }}
      >
        <svg
          viewBox="0 0 56 56"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
          }}
        >
          {/* Track circle */}
          <circle cx="28" cy="28" r="24" fill="none" stroke="#1F2937" strokeWidth="4" />
          {/* Spinner arc */}
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            stroke="#EF4444"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="100 50"
          />
        </svg>
      </div>
    </div>
  </>
);

export default LoadingScreen;
